import { customStyle, styleEnd } from "../../algorithms/styleDirection";
import { HubConnectionBuilder } from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import "./tasksStyle.css";
import TextArea from "../sharedComponents/textarea/textArea";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useRef, useState } from "react";
import { paths } from "../../paths/paths";
import moment from "moment";
import "moment/locale/ar";
import Button from "../sharedComponents/buttons/button";
import {
  addComment,
  getComments,
} from "./../../API/store/actions/comments/comments";
import { useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import * as Constant from "../../constant.module.json";

const TaskComments = ({ displayComments, setDisplayComments }) => {
  const userLogged = useSelector((state) => state.login.userData);
  const userToken = useSelector((state) => state.login.userToken);
  const [comments, setComments] = useState([]);

  const [connection, setConnection] = useState(null);
  const [connectionId, setConnectionId] = useState(null);

  const [inputText, setInputText] = useState("");

  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`${Constant.hubURLProjects}/commentHub`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
    setConnection(connect);
    return () => {
      connect.stop();
    };
  }, []);

  useEffect(() => {
    if (connection) {
      if (connection.state === "Disconnected") connection.start();
      connection.on("connected", (id) => {
        connection.invoke("JoinGroup", "taskComment" + displayComments.id);
        setConnectionId(id);
      });
      connection.on("ReceiveComment", (message) => {
        setDisplayComments({
          ...displayComments,
          content: [...displayComments.content, message],
        });
      });
    }
  }, [connection, displayComments.content]);
  useEffect(() => {
    if (displayComments.id) {
      setDisplayComments({ ...displayComments, content: [] });
      resolver(getComments, setComments, displayComments.id, userToken);
    }
  }, [displayComments.id]);

  useEffect(() => {
    if (comments?.data?.length)
      setDisplayComments({ ...displayComments, content: [...comments?.data] });
  }, [comments]);

  const sendMessage = async () => {
    const formData = new FormData();
    formData.append("Description", inputText);
    formData.append("UserId", userLogged.id);
    setInputText("");
    let res = await addComment(displayComments.id, formData, userToken);
    if (connection)
      await connection.invoke(
        "SendMessage",
        { ...res?.data },
        "taskComment" + displayComments.id
      );
  };

  if (Lang.getLanguage() === "ar") moment.locale("ar");
  else moment.locale("en");

  // const messagesEndRef = useRef(null);

  // const scrollToBottom = () => {
  //   messagesEndRef.current?.scrollIntoView();
  // };
  // // { behavior: "smooth" }

  // useEffect(() => {
  //   scrollToBottom();
  // }, [comments, displayComments]);
  // useEffect(() => {
  // }, []);
  let userPhoto;
  let newCreateDate = String(displayComments?.owner?.createDate).split(".")[0];
  if (displayComments?.owner?.memberPhoto)
    userPhoto = `url("${paths.ApplicantPhoto}${displayComments.owner.memberId}/${displayComments.owner.memberPhoto}")`;
  else userPhoto = `url("/assets/images/userPlaceholder.png")`;
  if (comments)
    return (
      <>
        {/* small screens to xl */}
        {displayComments.display ? (
          <div
            className={`scroll d-flex flex-column col-12 overflow-auto px-4`}
          >
            {displayComments.content.map((comment, index) => {
              let userPhoto; //let newCreateDate,
              // newCreateDate = procedure.createDate.split(".")[0];
              if (comment.memberPhoto != null)
                userPhoto = `url("${paths.ApplicantPhoto}${comment.memberId}/${comment.memberPhoto}")`;
              else userPhoto = `url("/assets/images/userPlaceholder.png")`;
              return (
                <div
                  className="p-2"
                  key={index}
                  style={{ wordBreak: "break-word" }}
                >
                  <div className="d-flex flex-row align-items-center">
                    <div className="d-flex align-items-center justify-content-start mb-2 mx-3 col-6">
                      <div
                        style={{
                          backgroundImage: userPhoto,
                          width: 40,
                          height: 40,
                          borderRadius: "50%",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          border: "1px solid white",
                        }}
                      ></div>
                      <p className="my-0 mx-1" style={{ fontWeight: "bold" }}>
                        {comment.memberName}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end col-6 px-5">
                      <div className="d-flex mb-2">
                        <span className="text-muted" style={{ fontSize: 14 }}>
                          {`${moment(new Date(comment.createDate)).format(
                            "lll"
                          )}`}{" "}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex px-4 align-items-center"
                    style={{
                      textAlign: "justify",
                      fontSize: 16,
                      color: "#444444",
                    }}
                  >
                    <p>{comment.description}</p>
                  </div>
                </div>
              );
            })}
            <div className="mt-4 mb-2 col-12 px-4">
              <TextArea
                placeholderAR="أكتب رسالة"
                placeholderEN="Write a message"
                rows="2"
                className="scroll col-12"
                onChange={(input) => {
                  setInputText(input.target.value);
                }}
                value={inputText}
              />
            </div>

            <div className="mb-3 px-4 d-flex ">
              <div className="col">
                <Button
                  onClick={sendMessage}
                  disable={!inputText}
                  content={Lang.send}
                />
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  return <>Loading</>;
};

export default TaskComments;
